<template>
  <div class="main">
    <roof-search :middleContent="false" :rightContent="false"></roof-search>
    <ul class="menu-main">
        <li v-for="item in list" :key="item.id" @click="gotoDetail(item.id)">
            <img v-if="item.img" :src="require('@/assets/img/' + item.img)" />
            <span v-else class="iconfont icon-col" :class="item.icon"></span>
            <span :class="item.type == '1' ?'span': ''">{{ item.name }}</span>
        </li>
    </ul>
  </div>
</template>

<script>
import roofSearch from '@/components/roof-search'
export default {
    components: {
        roofSearch
    },
    data () {
        return {
            list: [
                { id: '290', name: '基础科研', icon: 'icon-keyan' },
                { id: '291', name: '检验检测', icon: 'icon-jianyanbaogao' },
                { id: '296', name: '合成生物学', icon: 'icon-chanpinleibie-07' },
                { id: '295', name: '疫苗', icon: 'icon-yimiao' },
                { id: '294', name: '抗体', icon: 'icon-kangti' },
                { id: '293', name: '细胞/基因治疗', icon: 'icon-ganxibao',type: '1' },
                { id: '292', name: '外泌体', img: 'exosome.png' }
            ]
        }
    },
    methods: {
        gotoDetail(id) {
            this.$router.push({
                name: 'solutionList',
                query: {
                    id: id
                }
            })
            
        }
    }
}
</script>

<style lang="scss" scoped>
.main {
    position: relative;
    background: #f8f7fc;
    width: 100%;
    height: 100vh;
}
.menu-main {
    display: flex;
    flex-wrap: wrap;
    padding: rem(50) rem(21) 0 rem(21);
    li {
        display: flex;
        justify-content: start;
        align-items: center;
        width: rem(161);
        height: rem(104);
        margin-top: rem(30);
        margin-right: rem(11);
        padding-left: rem(16);
        background: url('https://cdn.juplus.cn/Fv7KBC_VpuJ6lJ_oLraeXWNfjxG2') no-repeat 100% 100%;
        background-size: cover;
        cursor: pointer;
        box-sizing: border-box;
        border-radius: rem(8);
        box-shadow: 0px 1px 5px 0px rgba(0,0,0,0.2);
        span:nth-child(1) {
            margin-right: rem(8);
            font-size: rem(45);
            color: #64c4d9;
        }
        span:nth-child(2) {
            font-size: 15px;
            font-weight: bold;
        }
        .span {
            width: rem(70);
            text-align: center;
            margin-right: rem(8);
        }
        img {
            height: rem(45);
            margin-right: rem(8);
        }
    }
    li:nth-child(even) {
        margin-right: 0;
    }
}
</style>